export default __webpack_public_path__ + "static/media/arrowR.968ae9c7.png";